import { useRef } from 'react';

import { useModal, ShowFnOutput } from 'mui-modal-provider';
import { Cluster } from '@cast/types';

import { CastctlOnboardClusterDialogProps } from '../components/CastctlOnboardingDialog';
import {
  ConnectClusterDialog,
  ConnectClusterDialogProps,
} from '../components/ConnectClusterDialog';

export const useCastctlOnboardingDialog = () => {
  const { showModal } = useModal();
  const showFnOutputRef =
    useRef<ShowFnOutput<ConnectClusterDialogProps>>(undefined);
  const handleClose = () => {
    showFnOutputRef.current?.destroy();
  };

  return {
    openCastctlOnboardingDialog: (
      props: Omit<
        CastctlOnboardClusterDialogProps,
        'onClose' | 'open' | 'onCompleted'
      > & {
        cluster?: Cluster;
        onCompleted?: () => void;
      } = {}
    ) => {
      const { cluster, onCompleted, ...dialogProps } = props;
      showFnOutputRef.current = showModal(ConnectClusterDialog, {
        cluster,
        ...dialogProps,
        onClose: handleClose,
        onCompleted: () => {
          onCompleted?.();
          handleClose();
        },
      });
    },
  };
};
